<table border="1">
    <thead>
      <tr>
        <th>Date</th>
        <th *ngFor="let category of categories">{{ category }}</th>
      </tr>
    </thead>
    <tbody>
      <!-- Loop through each date and display sales, svinn, and difference -->
      <tr *ngFor="let date of dates">
        <td>{{ date }}</td>
        <td *ngFor="let category of categories">
          <div>Sale: {{ getSale(date, category) || 0 }}</div>
          <div>Svinn: {{ getSvinn(date, category) || 0 }}</div>
          <!-- <div>Difference: {{ getDifference(date, category) || 0 }}</div> -->
        </td>
      </tr>
    </tbody>
  
    <!-- Footer row to display totals -->
    <tfoot>
      <tr>
        <th>Total</th>
        <td *ngFor="let category of categories">
          <div>Total Sale: {{ getTotalSale(category) }}</div>
          <div>Total Svinn: {{ getTotalSvinn(category) }}</div>
        </td>
      </tr>
      <tr>
        <th>Svinn Prosent</th>
        <td *ngFor="let category of categories">
        
          <!-- <div [style.background-color]="getProgressColor(category)"> {{ getTotalSvinnPercent(category)}} % </div> -->
          <div style="text-align: center;"> {{ getTotalSvinnPercent(category)}} % </div>
        </td>
      </tr>
      <tr>
        <th>Type</th>
        <th *ngFor="let category of categories">{{ category }}</th>
      </tr>
    </tfoot>
  </table>